module.exports = __webpack_public_path__ + "img/horcrux-nagini.3c0d44bc.png";